<div #facetsContainer class="facets-to-apply-container">
  @if (facetGroups.data?.length) {
    <div class="facet-group" *ngFor="let group of facetGroups.data">
      <div class="title">
        {{ group.name || group.code }}
      </div>
      <div class="facets">
        @if (group.type === FACET_TYPE.RADIO) {
          <div class="input-group">
            <div class="form-check w-100" *ngFor="let facet of group.values">
              <input
                class="form-check-input"
                type="radio"
                id="facet-{{ facet.name }}"
                value="{{ facet.name }}"
                name="subscriptiontype"
                [checked]="isChecked(facet)"
                (click)="getIt(group, facet)"
              />
              <label class="form-check-label" for="facet-{{ facet.name }}">
                {{ facet.name }}
              </label>
            </div>
          </div>
        } @else {
          <div
            class="form-check"
            *ngFor="let facet of isGroupExpanded(group.code) ? group.values : (group.values | slice: 0 : 5); let i = index"
          >
            <input
              class="form-check-input"
              type="checkbox"
              value=""
              [checked]="isChecked(facet)"
              id="facet_{{ facet.name }}"
              (click)="getIt(group, facet)"
            />
            <label class="form-check-label" for="facet_{{ facet.name }}"> {{ facet.name }}</label>
          </div>
        }

        @if (group.values && group.values.length > 5) {
          <button class="facets-to-apply-container-see-more" (click)="toggleExpand(group.code)">
            {{ isGroupExpanded(group.code) ? ('facets.seeLess' | translate) : ('facets.seeMore' | translate) }}
            <span class="material-symbols-outlined">{{ isGroupExpanded(group.code) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</span>
          </button>
        }
      </div>
    </div>
  } @else {
    <p>{{ 'facets.noFacets' | translate }}.</p>
  }
</div>
